<template>
  <div class="base-mit-tree-view">
    <v-card flat>
       <!-- <v-card-title class="primary white--text text-h5"> -->
       <v-card-title class="text-h5">
         <slot name="title" :titleText="title" >
             {{title}}
         </slot>
         <v-spacer></v-spacer>
         <v-text-field
           class="pr-5"
           v-model="search"
           append-icon="mdi-magnify"
           label="Search"
           single-line
           hide-details
         ></v-text-field>
       </v-card-title>
       <v-divider></v-divider>
       <v-row
         class="pa-4"
         justify="space-between"
       >
         <v-col cols="6" md="3">
           <v-card flat class="scroll">
               <v-treeview
                 dense
                 :active.sync="selected"
                 :items="items"
                 :search="search"
                 :item-key="itemKey"
                 :item-text="itemText"
                 transition
                 activatable
                 hoverable
                 return-object
                 :open.sync="open"
                 @update:active="nodeClicked"
               >
                 <template v-slot:prepend="{ item }">
                   <v-icon v-if="item.ui && item.ui.icon">{{item.ui.icon}}</v-icon>
                 </template>
               </v-treeview>
           </v-card>
         </v-col>

         <v-divider vertical></v-divider>

         <!-- <v-col class="d-flex"> -->
         <v-col cols="12" md="9">
             <v-card flat class="scroll">
                 <v-scroll-y-transition mode="out-in" duration="200">
                     <v-container v-if="selected.length <= 0" fill-height fluid>
                       <v-row align="center"justify="center">
                         <v-col>

                         </v-col>
                       </v-row>
                     </v-container>
                    <v-container v-else :key="selected[0].id">
                        <slot name="activeNodeDetails" :node="selected[0]">
                           <v-toolbar-title>{{selected[0].mitIdShort}}</v-toolbar-title>
                           <v-spacer></v-spacer>
                           <!-- SEARCH - disable search if totalItems is provided since this means we are using server side data-->
                           <p>details</p>
                        </slot>
                    </v-container>

                </v-scroll-y-transition>
            </v-card>
         </v-col>
       </v-row>
     </v-card>
  </div>
</template>

<script>

export default {
  name: 'BaseMitTreeView',
  components: {
  },
  props: {
    selectedNode:{
        default: [],
        type: Array
    },
    title: {
        default: 'Tree',
        type: String
    },
    openNodes:{
        default: [],
        type: Array
    },
    itemKey:{
        default:'id',
        type: String
    },
    itemText:{
        default:'name',
        type: String
    },
    items: {
      default: [],
      type: Array
    }
  },
  data: function() {
    return {
      search: null,
      open:[],
      selected:[]
    }
  },
  created() {

  },
  mounted() {
      //set any default open and/or selected nodes
      this.open = this.openNodes;
      this.selected = this.selectedNode;

      //Give the tree time to render then try to find a selected tree node.
      //this is the case if we want a node selected by default. The tree will not scroll to it automatically
      //So this scrolls to it.
      //Hacky... but I'm not sure how else to do this.
      setTimeout(() => {
          let container4 = this.$el.querySelector(".v-treeview-node--active");
          if(container4)
            container4.scrollIntoView();
      }, 500);
  },
  methods : {
    nodeClicked(node){
        this.$emit('click:node',node[0]);
    },
    treeExpand(node, level){
      if(node.children && level > 0){
        this.open.push(node);

        for(let x = 0; x < node.children.length; x++){
          this.treeExpand(node.children[x], (level - 1));
        }
      }
    },
    treeExpandAll(node){
      if(node.children){
        this.open.push(node);

        for(let x = 0; x < node.children.length; x++){
          this.treeExpandAll(node.children[x]);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    //fix for treeview only selecting part of a node name visually.
    //this happens if the tree has a horizontal scroll
    :deep(.v-treeview){
        width: max-content;
    }
    :deep(.v-treeview-node__label){
        overflow: initial;
        text-overflow: initial;
    }

    :deep(.v-navigation-drawer__content) {
        overflow-x: auto;
    }

    .scroll {
        max-height: calc(100vh);
        overflow-y: scroll;
    }
</style>
